import React,{Component} from 'react';
import {connect} from 'react-redux';
import {ClipLoader} from 'react-spinners';
import {Link} from 'react-router-dom';
import {createClient} from 'contentful';
import BlogCard from '../shared/BlogCard';
import {loadBlogs} from '../../store/blogs';
const client = createClient({
    space:'2jq9zineohv4',
    accessToken:'vBGOQA5tTUdmv9lIKmRKL1lPIg3QFsHId3_DPNikS3U'
});


class Blog extends Component {
    state = {
        orig_blogs:[],
        blogs:[],
        loading:true
    };

    componentDidMount = async() => {
        let {items} =  await client.getEntries().catch(console.log);  
        let blogs = [];      
        items.forEach((item) => {
            if(item.fields.author){
                blogs.push(item);
            }
        });
        let to_show = blogs.slice(0,3);
        this.props.loadBlogs(blogs);
        return this.setState({orig_blogs:blogs,blogs:to_show,loading:false});
    };

    

    render () {
        return (
            <section className="blog">
            <div className="row">

                <div className="col-12 col-sm-12 col-md-12">
                    <div className="blog_heading">
                        <h3>Blogs</h3>
                        <div className="blog_divider" />
                    </div>
                </div>
            </div>

            <div className="blog_content">
                <div className="row">
                    {
                        this.state.loading ? (
                            <div className="text-center" style={{width:'100%'}}><ClipLoader size="30" color="#009933" /></div>
                        ) : (
                            this.state.blogs.map((blog,index) => (
                                
                                <div className="col-12 col-sm-4" key={index}>
                                    <BlogCard data={blog} />
                                </div>

                            ))
                        )
                    }
                    {
                        this.state.orig_blogs.length > 3 ? (
                            <div className="col-12 col-sm-12 col-md-12 text-center">
                                <Link to="/blogs" className="btn btn-outline-success">
                                    view more
                                </Link>
                            </div>
                        ) : null
                    }
                </div>
            </div>
            </section>
        )
    }
};
const mapToProps = state => ({
    loading:state.blogs.loading
});
const dispatchToProps = {
    loadBlogs
};
export default connect(mapToProps,dispatchToProps)(Blog);